import { render, staticRenderFns } from "./availabilityDetails.vue?vue&type=template&id=35cafc8a&scoped=true"
import script from "./availabilityDetails.vue?vue&type=script&lang=js"
export * from "./availabilityDetails.vue?vue&type=script&lang=js"
import style0 from "./availabilityDetails.vue?vue&type=style&index=0&id=35cafc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cafc8a",
  null
  
)

export default component.exports